import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const LazyCodeMacroConfigurationPage: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ConfigureCodeMacroContainer" */ '../src/ConfigureCodeMacro/ConfigureCodeMacroPage.tsx'
			)
		).ConfigureCodeMacroPage,
});
